import { useState } from 'react';
import { ModuleListView } from '../modules/ModuleListView';

/**
 * QA/QC ▸ Internal Audit ▸ Correction Verification (Client Complaint and Nonconformity).
 * G5 puts a History button after Refresh that swaps the SAME frame to the Closed records
 * (`*_ListView_History`) — there is no separate menu entry for it. This wrapper does the same: the
 * Verification list, and on History the read-only History list. Clicking the menu entry again
 * remounts the page (standing rule 10) and lands back on the Verification list.
 */
export default function InternalAuditVerificationPage({ kind, group, onHome, navTitle }: {
  kind: 'cc' | 'nca';
  group: string;
  onHome: () => void;
  navTitle: string;
}) {
  const [history, setHistory] = useState(false);
  const moduleKey = `qa-${kind}-${history ? 'hist' : 'verif'}`;
  return (
    <ModuleListView
      key={moduleKey}
      moduleKey={moduleKey}
      group={group}
      navTitle={history ? `${navTitle} History` : navTitle}
      onHome={onHome}
      toolbarExtrasAfterRefresh={history ? undefined : (
        <button type="button" className="ca-btn" onClick={() => setHistory(true)} title="History">
          <span className="tb-i tb-i-green">🕘</span> History
        </button>
      )}
    />
  );
}
